module.exports = __webpack_public_path__ + "img/max-file-subtract--excel.e8a0a90a.svg";